import { ConferenceDataType, ConferenceType } from 'sections/PromoSection/pages/ConferencesPage/types'

import { createDate } from './createDate'
import { getMonthNumberOfDays } from './getMonthNumberOfDays'

type CreateMonthType = {
  locale?: string
  date?: Date
}

export const createMonth = (params?: CreateMonthType) => {
  const locale = params?.locale ?? 'default'
  const date = params?.date ?? new Date()

  const { monthName, monthNumber, monthIndex, year } = createDate({ date, locale })

  const getDay = (dayNumber: number) => {
    return createDate({ date: new Date(year, monthIndex, dayNumber), locale })
  }

  const createMonthDays = (conferenceData: ConferenceDataType = {}) => {
    const days = []

    for (let i = 0; i < getMonthNumberOfDays(monthIndex, year); i++) {
      const conferences: ConferenceType[] = (conferenceData[year]?.[monthIndex]?.[i + 1] ?? []).map((conference) => {
        return {
          ...conference,
          endDate: new Date(conference.endDate),
          startDate: new Date(conference.startDate),
        }
      })

      days.push({ ...getDay(i + 1), conferences })
    }

    return days
  }

  return {
    monthName,
    monthIndex,
    monthNumber,
    year,
    getDay,
    createMonthDays,
  }
}
